import { Action, ActionReducer, ActionReducerMap, combineReducers } from '@ngrx/store';
import { createReducer } from '@ngrx/store';
import * as managementReducer from './management/management.reducer';
import * as operationReducer from './operation/operation.reducer';
import * as deliveryReducer from './delivery/delivery.reducer';

export interface State {
  management: managementReducer.State;
  operation: operationReducer.State;
  delivery: deliveryReducer.State;
}

export const initialState: State = {
  management: managementReducer.initialState,
  operation: operationReducer.initialState,
  delivery: deliveryReducer.initialState,
};

const reducers = {
  management: managementReducer.reducer,
  operation: operationReducer.reducer,
  delivery: deliveryReducer.reducer,
};

export const reducer: ActionReducer<State> = combineReducers(reducers);
